import type { Challenge, ChallengeWeek } from '@/domain/workout'

/**
 * ¿Ha llegado ya la fecha de arranque de la semana?
 *
 * Es lo que decide si el entreno está a la vista: hasta su lunes, una semana
 * se anuncia pero no se puede abrir. Así nadie se adelanta al calendario.
 */
export function hasStarted(week: ChallengeWeek, today: Date = new Date()): boolean {
  return today >= new Date(`${week.startsOn}T00:00:00`)
}

/** El día que se abre, en cristiano: «lunes 10 de agosto». */
export function opensOnLabel(week: ChallengeWeek): string {
  const label = new Date(`${week.startsOn}T00:00:00`).toLocaleDateString('es-ES', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
  })
  // El formato del navegador mete una coma tras el día: sobra al leerlo.
  return label.replace(',', '')
}

/**
 * Semana que se muestra al abrir la app: la última que ya ha empezado.
 * Si el reto aún no ha arrancado, la primera. Es solo una sugerencia:
 * el alumno puede saltar a cualquier otra.
 */
export function currentWeekNumber(challenge: Challenge, today: Date = new Date()): number {
  const started = challenge.weeks.filter((week) => hasStarted(week, today))
  const last = started[started.length - 1] ?? challenge.weeks[0]
  return last?.number ?? 1
}

export function findWeek(challenge: Challenge, weekNumber: number): ChallengeWeek | undefined {
  return challenge.weeks.find((week) => week.number === weekNumber)
}
